import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  // La evaluación de Turomas no necesita la traza histórica y muy detallada
  // del optimizador en la consola del navegador. Se conservan warn y error.
  if (window.location.hostname === 'cut-turomas.vidrioservice.com') {
    console.log = () => undefined;
    console.debug = () => undefined;
    console.info = () => undefined;
  }
}

platformBrowserDynamic().bootstrapModule(AppModule);
